export const workHoursDe = {
    errors: {
        notEnabled: 'Arbeitsstunden sind für diese Organisation nicht eingerichtet.',
        accountNotFound: 'Stundenkonto nicht gefunden.',
        entryNotFound: 'Eintrag nicht gefunden.',
        ruleNotFound: 'Wähle eine Regel aus den Einstellungen der Arbeitsstunden.',
        ruleInUse: 'Regeln mit Stundenkonten können nicht entfernt werden. Deaktiviere sie stattdessen.',
        groupTypeRequired: 'Wähle den Gruppentyp der Gruppen, die die Stunden leisten.',
        accountRequired: 'Wähle ein Erlöskonto für Ersatzbeiträge und Ablösen.',
        accountRequired_at: 'Wähle ein Erlöskonto für Ersatzleistungen und Ablösen.',
        chartAccountNotFound: 'Das Konto {{account}} gibt es im Kontenrahmen nicht.',
        costCenterRequired:
            'Wähle die Kostenstelle 1. Der Kontenrahmen nutzt Regionen, daher braucht jeder Beleg eine.',
        invalidCostCenter: 'Wähle eine bebuchbare Kostenstelle eines Mandanten der Organisation.',
        accountSettled: 'Dieses Stundenkonto ist abgerechnet. Nimm die Abrechnung zuerst zurück.',
        notEditable: 'Dieser Eintrag kann nicht mehr geändert werden.',
        dateOutsidePeriod: 'Das Datum muss im Zeitraum {{period}} liegen.',
        dateInFuture: 'Arbeit kann nicht für künftige Tage erfasst werden.',
        wholeShifts: 'Schichten werden ganz gezählt.',
        helperRequired: 'Wähle, wer gearbeitet hat.',
        helperNotAllowed: 'Nur die Kontakte dieses Stundenkontos dürfen die Arbeit leisten.',
        notAllowed: 'Du kannst für dieses Stundenkonto keine Arbeit erfassen.',
        ownEntry:
            'Du kannst keine Arbeit freigeben, die für dein eigenes Stundenkonto oder das deiner Familie zählt. Eine andere prüfende Person muss das tun.',
        returnMessageRequired: 'Schreib dem Mitglied, was geändert werden muss.',
        tooMany: 'Wähle höchstens {{count}} auf einmal.',
        payerRequired: 'Wähle, wer für dieses Stundenkonto zahlt.',
        payerWithoutDebtor: '{{name}} hat noch kein Debitorenkonto, daher kann kein Beleg erstellt werden.',
        mandateRequired: 'Wähle den Mandanten, in dem Ersatzbeiträge und Ablösen gebucht werden.',
        mandateRequired_at: 'Wähle den Mandanten, in dem Ersatzleistungen und Ablösen gebucht werden.',
        directDebitCashAccountRequired: 'Wähle das Bankkonto, über das die Lastschriften eingezogen werden.',
        defaultMandateNotFound: 'Wähle einen der Mandanten der Organisation.',
        revokeNotPossible: 'Der Beleg wurde schon bezahlt, daher kann die Abrechnung nicht mehr zurückgenommen werden.',
        buyoutNotAvailable: 'Für dieses Stundenkonto gibt es keine Ablöse.',
        buyoutExpired: 'Die Ablöse konnte nur bis {{date}} gewählt werden.',
        buyoutChosen: 'Die Ablöse wurde für dieses Stundenkonto schon gewählt.',
        suggestionUsed: 'Dieser Arbeitseinsatz wurde schon erfasst.',
        holderDeleted: 'Der Kontakt oder die Gruppe dieses Stundenkontos wurde gelöscht.',
        deadlinePassed: 'Arbeit konnte nur bis {{date}} erfasst werden.',
        deadlineRunning:
            'Stundenkonten können abgerechnet werden, sobald keine Arbeit mehr erfasst werden kann, nach dem {{date}}.',
        entriesToReview: 'Einträge dieses Stundenkontos warten noch auf ihre Prüfung. Prüfe sie zuerst.',
        cashAccountNotFound: 'Wähle ein Bankkonto der Organisation, das im Buchungsmandanten verwendet werden kann.',
        periodStartLocked:
            'Der Beginn des Zeitraums kann nicht mehr geändert werden, da Stundenkonten im neuen Zeitraum schon Arbeit, Notizen oder Änderungen haben oder noch abgerechnet werden müssen.',
        ruleLocked:
            'Wer die Arbeit leistet und ihre Einheit können nicht mehr geändert werden, da Stundenkonten des laufenden Zeitraums schon Arbeit, Notizen oder Änderungen haben. Deaktiviere die Regel und lege stattdessen eine neue an.',
        approvalFailed: 'Der Eintrag konnte nicht freigegeben werden.',
        settlementFailed: 'Das Stundenkonto konnte nicht abgerechnet werden.',
    },
    quantity: {
        hours_one: '{{value}} Stunde',
        hours_other: '{{value}} Stunden',
        shifts_one: '{{value}} Schicht',
        shifts_other: '{{value}} Schichten',
    },
    notifications: {
        open: 'Stundenkonto öffnen',
        review: 'Eintrag prüfen',
        showAccounts: 'Arbeitsstunden zeigen',
        submittedTitle: 'Arbeitsstunden zu prüfen',
        submittedMessage: '{{helper}} hat {{quantity}} für {{rule}} erfasst ({{name}}).',
        submittedOnBehalfMessage: '{{submitter}} hat {{quantity}} von {{helper}} für {{rule}} erfasst ({{name}}).',
        returnedTitle: 'Deine Arbeitsstunden wurden zurückgegeben',
        returnedMessage: '{{activity}} am {{date}}: {{message}}',
        approvedTitle: 'Arbeitsstunden freigegeben',
        approvedMessage: '{{quantity}} für {{rule}} angerechnet. {{approved}} von {{required}} geleistet.',
        revokedTitle: 'Arbeitsstunden nicht mehr freigegeben',
        revokedMessage: '{{activity}} am {{date}} zählt nicht mehr für {{rule}}.',
        reminderTitle: 'Noch {{missing}} offen für {{rule}}',
        reminderMessage: 'Erfasse deine Arbeit bis {{deadline}}, sonst wird die fehlende Arbeit berechnet.',
        reminderMessageWithoutFee: 'Erfasse deine Arbeit bis {{deadline}}.',
        settledTitle: '{{rule}} {{period}} abgerechnet',
        settledMessage: '{{missing}} fehlen, {{amount}} werden berechnet.',
        settledFulfilledMessage: 'Alle Arbeit geleistet. Danke!',
        settledWithoutFeeMessage: '{{missing}} fehlen.',
        buyoutTitle: 'Ablöse für {{rule}} bestätigt',
        buyoutMessage: 'Statt der Arbeit in {{period}} werden {{amount}} berechnet.',
        deadlineSummaryTitle: 'Frist Arbeitsstunden {{period}}',
        deadlineSummaryMessage_one: '{{count}} Eintrag wartet noch auf deine Prüfung, bevor abgerechnet werden kann.',
        deadlineSummaryMessage_other:
            '{{count}} Einträge warten noch auf deine Prüfung, bevor abgerechnet werden kann.',
    },
    receipt: {
        feePosition: 'Ersatzbeitrag Arbeitsstunden – {{rule}} {{period}}',
        feePosition_at: 'Ersatzleistung Arbeitsstunden – {{rule}} {{period}}',
        feeDescription: '{{missing}} × {{fee}}',
        buyoutPosition: 'Ablöse Arbeitsstunden – {{rule}} {{period}}',
        buyoutDescription: '{{holder}}',
    },
}
